
import { createAsyncActionCreator, IAsyncActionCreator } from '../store/actions/createActionCreator';
import { currentItemFacet } from '../facets/ScopeFacets';
import { waitForNextStoreUpdate } from '../store/enhancers/NextStoreUpdateEnhancer';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { resolveItems } from './getItems';

/**
 * @public
 */
export interface IOpenItemPayload {
  itemsScopeItemKey: string;
  currentItemKey: string;
}

export const openItem: IAsyncActionCreator<IOpenItemPayload, IItemCacheThunkAction<void>> = createAsyncActionCreator((
  payload: IOpenItemPayload
): IItemCacheThunkAction<Promise<void>> => {
  const {
    itemsScopeItemKey,
    currentItemKey
  } = payload;

  return async (dispatch: IItemCacheDispatch) => {
    dispatch(resolveItems({
      items: {
        [itemsScopeItemKey]: {
          ...currentItemFacet.pack({
            itemKey: currentItemKey
          })
        }
      }
    }));

    await dispatch(waitForNextStoreUpdate());
  };
});
